import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { AUTH_OPTIONS } from "../../auth.options";
import { getDeepFromObject } from "../../helpers";

@Component({
    selector: "evta-logout",
    templateUrl: "./logout.component.html",
    standalone: false
})
export class LogoutComponent implements OnInit {

  redirectDelay: number = 0;
  strategy: string = "";

  constructor(
              @Inject(AUTH_OPTIONS) protected options = {},
              protected router: Router) {
    this.redirectDelay = this.getConfigValue("forms.logout.redirectDelay");
    this.strategy = this.getConfigValue("forms.logout.strategy");
  }

  ngOnInit(): void {
    this.logout(this.strategy);
  }

  logout(strategy: string): void {

  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
}
